import { ICoverageItem, IOtherCoverage } from './member-details.model';

export const filterCoverages = (status: string, coverages: any[]): any[] => {
  return coverages?.filter(
    (coverage: ICoverageItem | IOtherCoverage) => status.toUpperCase() === coverage.status.toUpperCase()
  );
};

export const mapCoverageResponse = (coverage): any => {
  return {
    planType: coverage?.planType,
    coverageGroupType: coverage.coverageGroupType,
    planName: coverage?.displayPlanCodeDescription || 'Description Unavailable',
    startDate: coverage.startDate,
    endDate: coverage.endDate,
    network: coverage?.network || 'Network Unavailable',
    status: coverage.eligibilityStatus,
    providerEligibility: null,
    type: coverage?.planTypeDescription || 'Type Unavailable',
    planStartDate: coverage?.planStartDate,
    planEndDate: coverage?.planEndDate,
    planCode: coverage?.planCode,
    groupNumber: coverage?.groupNumber,
    groupName: coverage?.groupName,
    subGroupNumber: coverage?.subGroupNumber,
    eligibilityTypeDescription: coverage?.eligibilityTypeDescription,
    isAso: coverage?.isAso,
    copay: coverage?.copay,
    memberRiders: coverage?.memberRiders,
    coinsurance: coverage?.coinsurance,
    mhLimits: coverage?.mhLimits,
    isFirstCarePlan: coverage?.isFirstCarePlan,
    segmentId: coverage?.segmentId,
    segmentDescription: coverage?.segmentDescription,
    lineOfBusiness: coverage?.lineOfBusiness
  };
};

export const compareOtherCoverages = (a: IOtherCoverage, b: IOtherCoverage): number => {
  if (a.isPrimaryCoverage && b.isPrimaryCoverage) {
    return 0;
  }
  if (a.isPrimaryCoverage) {
    return -1;
  }
  return 1;
};

export const convertPrimaryCoverages = (otherCoverages: IOtherCoverage[], memberIds: string[]): any => {
  const newPrimaryCoverages = otherCoverages?.map((coverage) => {
    return {
      ...coverage,
      isPrimaryCoverage: memberIds?.includes(coverage?.policyNumber)
    };
  });
  return newPrimaryCoverages?.sort(compareOtherCoverages);
};

export const getHixDescription = (code: string): string => {
  switch (code) {
    // Active
    case 'A01':
      return 'Payment received and effective date reached.';
    // Future
    case 'E01':
      return 'Payment received but the effective date has not been reached.';
    case 'P01':
      return 'Enrollment received but no payment made.';
    case 'P02':
      return 'Coverage is still pending payment. Total Amount Due including any past due balance on this account must be received on or before the due date or this member’s coverage will be voided.';
    // Termed
    case 'C01':
      return 'Coverage never became effective by CMS or because of a voluntary cancellation.';
    case 'C02':
      return 'Payment never received from member. Coverage never became effective.';
    case 'T01':
      return 'Member had an active span of coverage and coverage is now terminated.';
    case 'T02':
      return 'Member had an active span of coverage and coverage is now terminated.';
    case 'T03':
      return 'Member had an active span of coverage and coverage is now terminated.';
    // Grace
    case 'T30':
      return 'Health plans must provide a grace period of three consecutive months to members who are receiving tax credits and have previously paid at least one full month’s premium during the benefit year. Members are put into T30 status for days 1-30 payment has not been paid. The member is still within the payment grace period.';
    case 'T31':
      return 'Health Plans must provide a payment grace period of 30 days to members who are not receiving premium tax credits.  If a member fails to remit payment on or before the first of the month, the member will be placed into a T31 status.  Members have 30 days from the date they are placed into the T31 status to provide their premium payment.  If no payment is received, the policy will terminate effective as of the last day of the grace period.';
    case 'T60':
      return 'Health plans must provide a grace period of three consecutive months to members who are receiving tax credits and have previously paid at least one full month’s premium during the benefit year. Members are put into T60 status for days 31-60 payment has not been paid. The member is behind in payment but still within the payment grace period. Member’s pharmacy benefit has been shut off.';
    case 'T90':
      return 'Health plans must provide a grace period of three consecutive months to members who are receiving tax credits and have previously paid at least one full month’s premium during the benefit year. Members are put into T90 status for days 61-90 payment has not been paid. T90 members are pending termination. Member’s pharmacy benefit has been shut off.';
  }
};

export const addHixStatusesToCoverages = (coverages: ICoverageItem[], hixStatus: any): ICoverageItem[] => {
  const gracePeriodCodes = ['T30', 'T31', 'T60', 'T90'];
  const getInGracePeriod = (hixCode: string) => gracePeriodCodes.includes(hixCode);
  return coverages.map((coverage) => {
    if (coverage.status.toUpperCase() !== 'ACTIVE') {
      return coverage;
    } else {
      // apply hix information to active coverages
      return {
        ...coverage,
        hixStatus: hixStatus?.statusCode,
        hixDescription: getHixDescription(hixStatus?.statusCode),
        inGracePeriod: getInGracePeriod(hixStatus?.statusCode)
      };
    }
  });
};
